import { CheckUser, PaymentSuccess } from '@p2p/entities/payment';
import { PaymentTemplate, usePaymentTemplate } from '@p2p/entities/templates';
import { useGetMerchantOrderQuery, usePageSettings } from '@p2p/services';
import { useOutlet, useParams } from 'react-router-dom';

import { PaymentWarning } from '../PaymentWarning';
import { TransferRequestSuccess } from '../TransferRequestSuccess';
import { CheckPayment } from './CheckPayment';
import { SelectBank } from './components/SelectBank';
import { Step } from './components/Step';
import { PAYMENT_STEPS_IDS } from './Payment.constants';

export const PaymentPage = () => {
  const { setStepId } = usePaymentTemplate();
  const outlet = useOutlet();
  const { id = '' } = useParams<{ id: string }>();
  const { isLoading, data: order } = useGetMerchantOrderQuery(id, { skip: !id });
  const { data: pageSettings, isLoading: isLoadingPageSettings } = usePageSettings({ order });

  if (isLoading || isLoadingPageSettings || !order || !pageSettings) {
    return null;
  }

  return (
    <PaymentTemplate>
      <CheckPayment order={order} pageSettings={pageSettings} />
      {outlet || (
        <>
          <Step id={PAYMENT_STEPS_IDS.CHECK_USER}>
            <CheckUser
              pageSettings={pageSettings}
              onSuccess={() => setStepId(PAYMENT_STEPS_IDS.SELECT_BANK)}
            />
          </Step>
          <Step id={PAYMENT_STEPS_IDS.SELECT_BANK}>
            <SelectBank pageSettings={pageSettings} order={order} />
          </Step>
          <Step id={PAYMENT_STEPS_IDS.PAYMENT_SUCCESS}>
            <PaymentSuccess order={order} />
          </Step>
          <Step id={PAYMENT_STEPS_IDS.PAYMENT_WARNING}>
            <PaymentWarning order={order} pageSettings={pageSettings} />
          </Step>
          <Step id={PAYMENT_STEPS_IDS.IN_DISPUTE}>
            <TransferRequestSuccess order={order} id={id} />
          </Step>
        </>
      )}
    </PaymentTemplate>
  );
};
